if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.touchStartX = null;
        this.touchStartY = null;
        this.touchStartedWithMultipleFingers = false;

        this.addEventListener('touchstart', (event) => this.handleTouchStart(event), { passive: true });
        this.addEventListener('touchend', (event) => this.handleTouchEnd(event), { passive: true });
      }

      hide() {
        this.resetTouch();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.ensureImageCounter();
        this.showActiveMedia();
      }

      ensureImageCounter() {
        if (this.querySelector('.product-media-modal__counter')) return;

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;

        const counter = document.createElement('div');
        counter.className = 'product-media-modal__counter';
        counter.setAttribute('aria-live', 'polite');
        counter.setAttribute('aria-atomic', 'true');
        counter.hidden = true;
        dialog.appendChild(counter);
      }

      updateImageCounter(images, activeIndex) {
        const counter = this.querySelector('.product-media-modal__counter');
        if (!counter) return;

        if (images.length < 2 || activeIndex < 0) {
          counter.hidden = true;
          return;
        }

        counter.hidden = false;
        counter.textContent = `${activeIndex + 1} / ${images.length}`;
      }

      handleTouchStart(event) {
        this.touchStartedWithMultipleFingers = event.touches.length !== 1;

        if (this.touchStartedWithMultipleFingers) {
          this.resetTouch();
          this.touchStartedWithMultipleFingers = true;
          return;
        }

        const touch = event.touches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
      }

      handleTouchEnd(event) {
        if (
          !window.matchMedia('(max-width: 749px)').matches ||
          this.touchStartedWithMultipleFingers ||
          this.touchStartX === null ||
          this.touchStartY === null ||
          event.changedTouches.length !== 1
        ) {
          this.resetTouch();
          return;
        }

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;

        this.resetTouch();

        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;

        this.showAdjacentImage(deltaX < 0 ? 1 : -1);
      }

      resetTouch() {
        this.touchStartX = null;
        this.touchStartY = null;
        this.touchStartedWithMultipleFingers = false;
      }

      animateImage(image, direction) {
        const animationClass =
          direction > 0 ? 'product-media-modal__image--from-right' : 'product-media-modal__image--from-left';

        image.classList.remove(
          'product-media-modal__image--from-right',
          'product-media-modal__image--from-left'
        );
        image.classList.add(animationClass);
        image.addEventListener('animationend', () => image.classList.remove(animationClass), { once: true });
      }

      showAdjacentImage(direction) {
        const images = Array.from(
          this.querySelectorAll('.product-media-modal__content > img[data-media-id]')
        );
        const activeMedia = images.find((image) => image.classList.contains('active'));

        if (!activeMedia || images.length < 2) return;

        const currentIndex = images.indexOf(activeMedia);
        const nextIndex = currentIndex + direction;

        if (nextIndex < 0 || nextIndex >= images.length) return;

        activeMedia.classList.remove('active');
        const nextImage = images[nextIndex];
        nextImage.classList.add('active');
        this.animateImage(nextImage, direction);
        this.updateImageCounter(images, nextIndex);

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const images = Array.from(
          this.querySelectorAll('.product-media-modal__content > img[data-media-id]')
        );
        this.updateImageCounter(images, images.indexOf(activeMedia));

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
